<template>
  <div class="ui segment" :class="{ loading: isLoading }">
    <h2 class="ui dividing header">{{ header }}</h2>

    <sui-segment basic floated="right">
      <sui-dropdown
        placeholder="Elementos por página"
        selection
        collapsing
        :options="pageQuantity"
        v-model="recordsPerPage"
      />
    </sui-segment>
    <sui-segment basic floated="left">
      <div class="ui action left icon input">
        <i class="search icon"></i>
        <input type="text" :placeholder="header" />
        <div class="ui teal button">Buscar</div>
      </div>
    </sui-segment>

    <div class=""></div>
    <table class="ui celled striped selectable table">
      <thead>
        <tr>
          <th v-for="column in columns">{{ column.header }}</th>
          <th class="collapsing">
            <div class="ui center aligned" v-if="addButtonLabel">
              <button type="button" class="ui mini  positive button">
                <i class="plus icon"></i>
                {{ addButtonLabel }}
              </button>
            </div>
            <div class="ui center aligned"></div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="pageContent" v-for="item in pageContent">
          <td
            v-for="column in columns"
            :class="{ collapsing: column.type === 'image' }"
          >
            <div v-if="column.type === 'image'">
              <sui-image :src="cellValue(item, column)" size="small" />
            </div>
            <div v-if="column.type === 'date'">
              {{ cellValue(item, column) | moment('DD/MM/YYYY hh:mm a') }}
            </div>
            <div v-if="column.type === 'money'">
              {{ cellValue(item, column) | numeralFormat('$0,0.00') }}
            </div>
            <div v-if="column.type === 'status'">
              <div
                class="ui horizontal label"
                :class="getStatusClass(item, column)"
              >
                {{ getStatusString(item, column) }}
              </div>
            </div>
            <div v-if="!column.type">
              {{ cellValue(item, column) }}
            </div>
          </td>
          <td class="collapsing">
            <a
              class="ui icon basic primary mini button"
              @click="openEdit(item._id)"
              ><i class="eye icon"></i
            ></a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th :colspan="columns.length + 2">
            <div class="">
              <div class="ui left floated tiny header">
                <b>Total:</b> {{ totalElemnts }}
              </div>
              <div class="ui right floated ">
                <paginate
                  v-model="currentPage"
                  :page-count="totalPages"
                  :click-handler="onPageChange"
                  :prev-text="'<'"
                  :prev-link-class="'item'"
                  :next-text="'>'"
                  :next-link-class="'item'"
                  :container-class="'ui right floated pagination menu'"
                  :page-link-class="'item'"
                  :no-li-surround="true"
                >
                </paginate>
              </div>
            </div>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Catalog',
  props: ['store', 'header', 'addButtonLabel', 'columns', 'editOn', 'addOn'],
  data: function() {
    return {
      recordsPerPage: 10,
      isLoading: false,
      searchTerm: {},
      currentPage: 1,
      pageQuantity: [
        {
          text: '10 por página',
          value: 10
        },
        {
          text: '20 por página',
          value: 20
        },
        {
          text: '30 por página',
          value: 30
        }
      ]
    };
  },
  created: function() {
    this.loadPage();
  },
  watch: {
    recordsPerPage: function(val) {
      this.loadPage(1);
    }
  },
  computed: {
    pageContent: function() {
      return this.$store.getters[this.store + '/getPageContent'];
    },
    totalPages: function() {
      return this.$store.getters[this.store + '/getTotalPages'];
    },
    totalElemnts: function() {
      return this.$store.getters[this.store + '/getTotalElemnts'];
    },
    statetPage: function() {
      return this.$store.getters[this.store + '/getCurrentPage'];
    }
  },
  methods: {
    getStatusClass: function(item, column) {
      if (column.labels) {
        const status = this.cellValue(item, column);
        const label = column.labels.find(l => l.value === status);
        return label.class;
      } else {
        return '';
      }
    },
    getStatusString: function(item, column) {
      if (column.labels) {
        const status = this.cellValue(item, column);
        const label = column.labels.find(l => l.value === status);
        return label.display;
      } else {
        return this.cellValue(item, column);
      }
    },
    cellValue: function(item, column) {
      if (column.concat) {
        const p1 = _.get(item, column.property);
        const p2 = _.get(item, column.concat);
        return p1 + ' ' + p2;
      }
      return _.get(item, column.property);
    },
    remove: function(id) {
      console.log('removing object ' + id);
    },
    onPageChange: function(page) {
      this.loadPage(page);
    },
    loadPage: async function(page) {
      this.isLoading = true;
      const pageNumber = page ? page : this.statetPage;
      await this.$store.dispatch(this.store + '/loadPage', {
        size: this.recordsPerPage,
        page: pageNumber
      });
      this.isLoading = false;

      this.currentPage = this.statetPage;
    },
    openEdit: function(id) {
      this.$router.push(this.editOn + '/' + id);
    }
  }
};
</script>

<style lang="css" scoped></style>
